import LLGlobeTrotter from '@/locales/GlobeTrotter/fr';
import LLTrendingNow from '@/locales/TrendingNow/fr';
import LLEdito from '@/locales/Edito/fr';
import LLTravel from '@/locales/Travel/fr';
import LLTune from '@/locales/Tune/fr';
import LLFuture from '@/locales/Future/fr';
import LLArty from '@/locales/Arty/fr';
import LLKeyReport from '@/locales/KeyReport/fr';
import LLEntrepreneurs from '@/locales/Entrepreneurs/fr';
import LLSummit from '@/locales/Summit/fr';
import LLEssential from '@/locales/Essential/fr';
import LLLegal from '@/locales/Legal/fr';

export const  fr = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoLU: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoUK: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoFR: {
            segment: 'edito',
            title: 'Édito',
        },
        EditoMC: {
            segment: 'edito',
            title: 'Édito',
        },
        Essential: {
            segment: 'les-essentiels',
            title: 'Les essentiels',
        },
        TrendingNow: {
            segment: 'tendances',
            title: 'Tendances',
        },
        GlobeTrotter: {
            segment: 'planete-insolite',
            title: 'Planète insolite',
        },
        Travel: {
            segment: 'suisse-contre-courant',
            title: 'La Suisse à contre-courant',
        },
        Summit: {
            segment: 'marie-bochet-vie-intensement',
            title: 'Marie Bochet, la vie, intensément',
        },
        Tune: {
            segment: 'gisele-magnan-toujours-voulu-etre-utile',
            title: 'Gisèle Magnan&nbsp;: «&nbsp;J’ai toujours voulu être utile&nbsp;»',
        },
        Future: {
            segment: 'inspirer-vivant-repenser-notre-societe',
            title: 'S’inspirer du vivant pour repenser notre société',
        },
        Arty: {
            segment: 'lorenza-longhi-explore-espace',
            title: 'Lorenza Longhi explore l’espace',
        },
        KeyReport: {
            segment: 'e-sport-gagne-terrain',
            title: 'L’e-sport gagne du terrain',
        },
        Entrepreneurs: {
            segment: 'richard-tipper-optimiste-realiste',
            title: 'Richard Tipper, un optimiste réaliste',
        },
        Legal: {
            segment: 'credits-informations-legales',
            title: 'Credits & informations légales',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    Essential: LLEssential,

    EditoCH: LLEdito,
    EditoLU: LLEdito,
    EditoUK: LLEdito,
    EditoFR: LLEdito,
    EditoMC: LLEdito,

    TrendingNow: LLTrendingNow,

    GlobeTrotter: LLGlobeTrotter,

    Travel: LLTravel,
    Tune: LLTune,

    Future: LLFuture,

    Arty: LLArty,

    KeyReport: LLKeyReport,

    Entrepreneurs: LLEntrepreneurs,

    Summit: LLSummit,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Voir le monde différemment&nbsp;avec <br />Société&nbsp;Générale Private&nbsp;Banking <br/>Printemps 2021 #6',
        title: 'Marie Bochet <br />La vie, intensément',
        artitle1title: 'Ils pensent le futur',
        artitle1content: 'S’inspirer du vivant pour repenser notre société',
        artitle2title: 'Le grand dossier',
        artitle2content:  'L’e-sport gagne du terrain',
        artitle3title: 'Voyager différemment',
        artitle3content:  'La Suisse à contre-courant',
    },

    next: 'À suivre : ',

    welcome_message : 'FR - Welcome to Your Vue.js App',
    popular_links : 'FR - Popular Links',
    ecosystem : 'FR - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: '&nbsp;',
    counterUpDecimal: ',',
};
